import type { z } from "zod";

import { authClient, betterAuthErrorText } from "lib/auth/authClient";

/**
 * Calls an OAuth-provider endpoint and validates the response.
 *
 * These go through `$fetch` rather than a typed client action because `oauthProviderClient()`
 * declares `$InferServerPlugin: {}`, so it adds no typed surface — and installing it would inject
 * an `oauth_query` field into every non-GET request the auth client makes, not just these.
 */
export async function mcpFetch<T extends z.ZodType>(
  path: string,
  schema: T,
  init: { method: "GET" | "POST"; body?: unknown },
  fallbackError: string,
): Promise<z.infer<T>> {
  const { data, error } = await authClient.$fetch(path, init);

  if (error) {
    throw new Error(betterAuthErrorText(error, fallbackError));
  }

  return schema.parse(data);
}
